
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 21c4.95 0 9-4.05 9-9s-4.05-9-9-9M12 21c-2.931 0-5.538-1.426-7.184-3.612","stroke":"#323232","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.816 17.388A8.931 8.931 0 013 12c0-4.95 4.05-9 9-9","stroke":"#323232","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","stroke-dasharray":"0"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M12 16.5S8.5 13.625 8.5 11a3.5 3.5 0 117 0c0 2.625-3.5 5.5-3.5 5.5z","stroke":"#323232","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M11.999 10.85a.25.25 0 10.002.5.25.25 0 00-.002-.5","stroke":"#323232","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    